if (!customElements.get('video-popup')) {
  class VideoPopup extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('basic-modal');
      this.trigger = this.querySelector('.video-popup-trigger');
      this.trigger?.addEventListener('click', this.onTriggerClick);
      this.modal?.addEventListener('modal:handleAfterHide', this.onHide);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.onTriggerClick);
      this.modal?.removeEventListener('modal:handleAfterHide', this.onHide);
    }

    get player() {
      return this.querySelector('.video-popup-modal video');
    }

    onTriggerClick = (event) => {
      event.preventDefault();

      const video = this.player;
      if (this.modal) {
        this.modal.hidden = false;
        if (!this.modal.open) {
          this.modal.show(this.trigger, false);
        }
      }
      if (!video) return;

      video.controls = true;
      video.playsInline = true;
      video.muted = true;
      video.defaultMuted = true;

      const unmute = () => {
        video.muted = false;
        video.defaultMuted = false;
        video.volume = 1;
      };

      const attempt = video.play();
      if (attempt && typeof attempt.then === 'function') {
        attempt
          .then(() => {
            unmute();
            if (video.paused) {
              video.play().catch(() => {});
            }
          })
          .catch(() => {
            video.muted = true;
            return video.play().then(unmute);
          })
          .catch(() => {});
      } else {
        unmute();
      }
    };

    onHide = () => {
      const video = this.player;
      if (!video) return;
      video.pause();
      video.muted = true;
      const start = Number(this.dataset.startSeconds || 0);
      if (Number.isFinite(start)) {
        video.currentTime = start;
      }
    };
  }

  customElements.define('video-popup', VideoPopup);
}
